<template>
  <v-row class="form-range">
    <v-col
      v-for="i in 10"
      :key="i"
      cols="1"
    >
    <!-- stepper (1 to 10) container -->
      <v-btn
        icon
        small
        @click="select(i)"
        :class="{ 'primary white--text': selected === i }"
      >
        {{ i }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<style scoped>
.form-range {
  padding-right: 24px;
}
</style>

<script>
export default {
  name: 'FormModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selected: -1,
  }),
  methods: {
    select(i) {
      this.selected = i;
      this.$emit('select', i);
    },
  },
};
</script>
